// Extract the integer ID from the base64 encoded graphql ID
export default function extractId(graphqlId: string): number | null {
  try {
    return parseFloat(atob(graphqlId).split(':')[1]);
  } catch (e) {
    return null;
  }
}
